import { acceptHMRUpdate, defineStore } from 'pinia';
import { JobHistoryType } from '@/types/pages/candidate/JobHistory';
const initialState: JobHistoryType = {
  work_experience_description: undefined,
};

export const useJobHistoryStore = defineStore('jobHistory.store', {
  state: (): JobHistoryType => ({ ...initialState }),
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useJobHistoryStore, import.meta.hot));
}
